
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as oryp1AqPzQw7k2CdSk9wY2n2pu_MDYbMAtwrHLWQUI_45GiMMeta } from "/build/incl/pages/ory.vue?macro=true";
import { default as liveCD9WWhFHbbR7tg_45CuABya4UlmebpVhjGxlMwSq71if0Meta } from "/build/incl/pages/live.vue?macro=true";
import { default as indexUrIPA1LVRbGONso3z_Y_NE1o8gpuEVAwMTDWLxZc5oQMeta } from "/build/incl/pages/index.vue?macro=true";
import { default as index0G8ChuPpgY1LTmlaAbyG2ecuxGQtsbtoBGW59XXFfcsMeta } from "/build/incl/pages/admin/mam/index.vue?macro=true";
import { default as _91kind_93CwxPwVvHorrWREvCBzRhUsNG07f3iUW3ErvwU_9Y33sMeta } from "/build/incl/pages/admin/mam/[kind].vue?macro=true";
import { default as mam85G5a_45TSexxkaG_2bLqP_PoXgo8ZwJazB3COlaPWQWEMeta } from "/build/incl/pages/admin/mam.vue?macro=true";
import { default as box_45officesn7igMTSxXVq4zfh0AlGQy71qhGJ1yrMj3Ih1khJzkUMeta } from "/build/incl/pages/box-office.vue?macro=true";
import { default as teamsHI4ZXQNj0PCp07odMit8IG3oddYseCCNJr7lU6S6Bf8Meta } from "/build/incl/pages/admin/teams.vue?macro=true";
import { default as users9uDKxsCubVrQzuBeud2nEeVEeyXNfh5Au4zHxZDI0qMMeta } from "/build/incl/pages/admin/users.vue?macro=true";
import { default as indexzFObHOqlcI7gEk7Ap4pCTk6RpMoOKLLp1GDzuBE3g34Meta } from "/build/incl/pages/judge/index.vue?macro=true";
import { default as sharingSghbv5Vuh9yFsetND5CpPKReIndGN7XnwsbFVPU7w4UMeta } from "/build/incl/pages/admin/sharing.vue?macro=true";
import { default as indexd0dYP8eezP4prIMFg2umiGrjlPtFiG1qizF5qSUkktYMeta } from "/build/incl/pages/archive/index.vue?macro=true";
import { default as save_45the_45datesiiga4OTgZrtS8INkxrEqb67qkQddeCzHQHupDBh6RMcMeta } from "/build/incl/pages/save-the-dates.vue?macro=true";
import { default as indexBKR2tkqWgiH_vEdwP3C5xRkdYH5D2P8897kmY47PHkoMeta } from "/build/incl/pages/selection/index.vue?macro=true";
import { default as indexv3GZZ8MQGMNQzJfe3Wrwco4mOlkdXLWD1VM3vBswgVcMeta } from "/build/incl/pages/admin/studio-links/index.vue?macro=true";
import { default as _91teamId_93mr7GtXwcR6yTFPgGLj4y9H0v5W7x_45fYUSNKRKf3lVFcMeta } from "/build/incl/pages/admin/studio-links/[teamId].vue?macro=true";
import { default as studio_45linksdVKI0Mo_45ISoh8I5DCg9xXKLMHq4F0yugeNI1PGdD5_45MMeta } from "/build/incl/pages/admin/studio-links.vue?macro=true";
import { default as indexMH_453EAaQY_yGk8CS2z6S17Ewyc3X2nyUh2tIUGu5SNgMeta } from "/build/incl/pages/admin/group-manager/index.vue?macro=true";
import { default as indexVV29kKcDzRiwF206oDvwFKn8zxUpTWiXSx7xtegveqsMeta } from "/build/incl/pages/admin/group-manager/[groupId]/index.vue?macro=true";
import { default as peoplemj_EdMiycA_45i5o1re93TbOgACAG3vHLgZcKlaaPfqVIMeta } from "/build/incl/pages/admin/group-manager/[groupId]/people.vue?macro=true";
import { default as _91groupId_93ewQgYo2loac8YKkkAAlQFh2Ny0skoQTY3g592mD7yOwMeta } from "/build/incl/pages/admin/group-manager/[groupId].vue?macro=true";
import { default as group_45managerp8RSjL3WeJmxzqXAYo8PhaDEXytj7RB_M8yBMxpUsMwMeta } from "/build/incl/pages/admin/group-manager.vue?macro=true";
import { default as registrationsMjm_45oCiLXlwtCnSXjUmvgYuhw2r_45UuoKHZkhZLIkOSAMeta } from "/build/incl/pages/admin/registrations.vue?macro=true";
import { default as indexh9_Z2MeuVr1x3xbFMMzA07bdyTsynWZGnlU_45VopNVxYMeta } from "/build/incl/pages/admin/results/index.vue?macro=true";
import { default as judgepIdIRoJc_0HDC0RxUXy7pfnM4cUnvcTj6b7W1Dynm2QMeta } from "/build/incl/pages/admin/results/judge.vue?macro=true";
import { default as _91filmGroupId_93tm0QG_dnn3YVE6do_uRIHm_45biFDjA7akdMouEQDBW8gMeta } from "/build/incl/pages/judge/[filmGroupId].vue?macro=true";
import { default as indexDkqZo3iQrnW0ZcjWIATMz2nEjKfcfed7bec4xyE4BXkMeta } from "/build/incl/pages/prize-sponsor/index.vue?macro=true";
import { default as indexsrz9o1hEh_4558VFTNREw8krBJSQubm9LX_NgzPrV95NEMeta } from "/build/incl/pages/admin/results/[year]/index.vue?macro=true";
import { default as indexUD_45Lxq_45gRZMkG5bibKxQmsrCP3A7LM4Dc0INztIzQLAMeta } from "/build/incl/pages/admin/results/[year]/[section]/index.vue?macro=true";
import { default as _91category_93Uw_45gG7t_G1a5_45v7hhUJRRIRAeuxwngM7rKRc9kEbplMMeta } from "/build/incl/pages/admin/results/[year]/[section]/[category].vue?macro=true";
import { default as _91section_93v3XiKdkJPo3FjD21L23yn6WW9rz1p5mk5MtUqNWqs68Meta } from "/build/incl/pages/admin/results/[year]/[section].vue?macro=true";
import { default as _91year_93cZik50_45CpV63vSfLOgVpvH95CWfsKUDT9Y7g8jivCdsMeta } from "/build/incl/pages/admin/results/[year].vue?macro=true";
import { default as indexu5415_3_45bHpdEyZJmqHDRKYVe5HItTpThH_45URrg5w5sMeta } from "/build/incl/pages/archive/[year]/index.vue?macro=true";
import { default as indexcFkoDdB7HoX1KTYVEaBiZ0i6886D3pZ92tmH3gc86JAMeta } from "/build/incl/pages/film-challenge/index.vue?macro=true";
import { default as exit_45interviewsWNdSBkVNE1Ca1Lma_LaUGe8IUpuGdeEqd9k67o3LhnIMeta } from "/build/incl/pages/admin/exit-interviews.vue?macro=true";
import { default as academy2Il9jadQtxyB86RX5bPfWWTUPyk6rDitytv70s3x9lUMeta } from "/build/incl/pages/admin/results/academy.vue?macro=true";
import { default as top_4510lxVGjQ4qxGr_45lm0MAB6powoLNAfocCWA2_iskRzRUBkMeta } from "/build/incl/pages/archive/[year]/top-10.vue?macro=true";
import { default as index9O6qUYqmSxskPgI1l40TxoHjVTqsZWnegnX_456x2MhigMeta } from "/build/incl/pages/archive/studios/index.vue?macro=true";
import { default as createEkBK2FrRdzxS_45bc0wztX6arIy5ZWJBGh7mUaMcwbiboMeta } from "/build/incl/pages/fivefest/films/create.vue?macro=true";
import { default as indexcxtraaN9GFmnjICmWtAS5DNY06iWEn1HQ6rN_45HsTmY8Meta } from "/build/incl/pages/archive/fivefest/index.vue?macro=true";
import { default as indexEDwisKdQM0lWUM0qP6o_BSAbEOKLcZjZwb9dFX7HfVcMeta } from "/build/incl/pages/fivefest/academy/index.vue?macro=true";
import { default as indexpRXNOruHMjjYcVvkuK_45uVGg75usWKDGiVCxzcj4_45Tz8Meta } from "/build/incl/pages/online-screening/index.vue?macro=true";
import { default as filmsvGYwJAa_45HBhqKxN2GvymK2HXNDiSj2zBPdDycSwqxiUMeta } from "/build/incl/pages/admin/film-groups/films.vue?macro=true";
import { default as userseuILGxupdVvrfT8NhqYwxWPQTLX_bJWtl2HJ51LYxjAMeta } from "/build/incl/pages/admin/film-groups/users.vue?macro=true";
import { default as selectionSCrlwFnUJM12hv66r_45PAVw9uYNRqFni7A5CAuM_45DinYMeta } from "/build/incl/pages/admin/results/selection.vue?macro=true";
import { default as _91teamId_93xskxNE9mYdJ_4589wgGX6Hu9gn3kVqKjZoOKZaALfalHAMeta } from "/build/incl/pages/archive/[year]/[teamId].vue?macro=true";
import { default as indexMTKkQvmvMjkOxn0YC_ONURX85SxDYYRUwfahWTjvgOwMeta } from "/build/incl/pages/admin/award-winners/index.vue?macro=true";
import { default as _91year_93WhhiNW2hZxr2id4HDewoAGmZx_45tWt2MLIAFaN5FB3UMMeta } from "/build/incl/pages/admin/award-winners/[year].vue?macro=true";
import { default as _91studioId_93M_459J3Ck21XksQoJW65utxw5aESBvAA20RtqG2felEhMMeta } from "/build/incl/pages/archive/studios/[studioId].vue?macro=true";
import { default as inspirationYYPLkItHc1WXeBCux84cfDFqJ6_e_45hNw0GMNU9SATMkMeta } from "/build/incl/pages/film-challenge/inspiration.vue?macro=true";
import { default as the_45matchupQQa_cfRzEZFjom3NsLs7ZHp4BQiUjvrR0M45k4rJJYwMeta } from "/build/incl/pages/film-challenge/the-matchup.vue?macro=true";
import { default as indexqiTVrx764X1heMh3eSCNkn9hkiyOcidGFA56FcsLDrsMeta } from "/build/incl/pages/archive/[year]/events/index.vue?macro=true";
import { default as _91kind_930KmSbTwm01G4RbSpzNuTCydSDbTPIaD4W3Fs44azva8Meta } from "/build/incl/pages/archive/[year]/events/[kind].vue?macro=true";
import { default as indexX0rqJiGhjhSK8iVLZdpK3frf4fwUupV1Mjvg6YfRqJkMeta } from "/build/incl/pages/admin/audience-favorite/index.vue?macro=true";
import { default as checkin_16RLIFsheEBLes8llqQ61HVvtd6vcQf_45e2cm4JyxVAMeta } from "/build/incl/pages/admin/awards-ceremony/checkin.vue?macro=true";
import { default as indexwgnum0_MoMNt78_45Enh5_hzTu3oZR6AjEUx19wZ5lbP4Meta } from "/build/incl/pages/archive/fivefest/[year]/index.vue?macro=true";
import { default as _91submissionId_933DqWLTY3fTviFNX8Wv6VrSNAvMDRLya9hJYnEZo1hCgMeta } from "/build/incl/pages/fivefest/films/[submissionId].vue?macro=true";
import { default as indexhkqA9n7hgIAHh0iYlM817CqMz5aPMxsR5MktmOlv9W8Meta } from "/build/incl/pages/selection/[filmGroupId]/index.vue?macro=true";
import { default as _91filmGroupId_93VepQ0Crf0AlAUy_ghmlHHlNYokgb6bWlu8lh3x_jWRUMeta } from "/build/incl/pages/online-screening/[filmGroupId].vue?macro=true";
import { default as reviewirXv0gPSFK6PiuXXLOexBuD0XjCIjSRb7KE_45Y2hTZ_45AMeta } from "/build/incl/pages/selection/[filmGroupId]/review.vue?macro=true";
import { default as indexOFjQ9XB1BQx8Ideaq0kNfYOe_45gxYeLaxZO0TMCczTFAMeta } from "/build/incl/pages/online-screening/five-fest/index.vue?macro=true";
import { default as _91filmGroupId_93WQZwPOA609JX7TlVAMLKGEsdn3Tg4TApveEZ7hpf62IMeta } from "/build/incl/pages/admin/audience-favorite/[filmGroupId].vue?macro=true";
import { default as _91submissionId_93868JSKc_34qHnEjrauGYEAKvPoOSbq84duvru9sRw_45kMeta } from "/build/incl/pages/archive/fivefest/[year]/[submissionId].vue?macro=true";
import { default as index3jhHoFoRQrIJXxIlKJjv_45E8dBLFHuNSoUmOb_GPsE7gMeta } from "/build/incl/pages/film-challenge/studios/[studioId]/index.vue?macro=true";
import { default as _91hash_93zER179T2yvVKapICOIeKdZY8SpQFpi1ZJ6X1BqITnDIMeta } from "/build/incl/pages/film-challenge/guest-registration/[hash].vue?macro=true";
import { default as _91filmGroupId_93kGdNuzSyAOx1U6D_45yJMpP_l70rsXrc3oPFwt6t5vMc0Meta } from "/build/incl/pages/online-screening/five-fest/[filmGroupId].vue?macro=true";
import { default as indexO5N4hx5MbSW0rppfO0gB18PLxehtYXQT_MmgT5I1zYsMeta } from "/build/incl/pages/fivefest/academy/film-groups/[filmGroupId]/index.vue?macro=true";
import { default as _91submissionId_93AMy1cEKsVM_45RGR567MwIo18c9xOzWF1J6GocPcvOrsEMeta } from "/build/incl/pages/fivefest/academy/film-groups/[filmGroupId]/[submissionId].vue?macro=true";
import { default as _91filmGroupId_930tbFWWYp6vF8L9wpJFfYa6fK5D4VoZC_45Coue9G0HACIMeta } from "/build/incl/pages/fivefest/academy/film-groups/[filmGroupId].vue?macro=true";
import { default as createVTWnBRbU0ZYcQQFnEbbzcXhJwN2PZFR9WHiwtdjOutEMeta } from "/build/incl/pages/film-challenge/studios/[studioId]/teams/create.vue?macro=true";
import { default as _91teamId_93BzC8VqAlxC5IIRKMa_45_45_45jwxN_45q_45e7SQdaNqk8htgvjwMeta } from "/build/incl/pages/film-challenge/studios/[studioId]/teams/[teamId].vue?macro=true";
export default [
  {
    name: "ory",
    path: "/ory",
    component: () => import("/build/incl/pages/ory.vue")
  },
  {
    name: "live",
    path: "/live",
    component: () => import("/build/incl/pages/live.vue")
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/index.vue")
  },
  {
    name: mam85G5a_45TSexxkaG_2bLqP_PoXgo8ZwJazB3COlaPWQWEMeta?.name,
    path: "/admin/mam",
    meta: { ...(mam85G5a_45TSexxkaG_2bLqP_PoXgo8ZwJazB3COlaPWQWEMeta || {}), ...{"middleware":["role"]} },
    component: () => import("/build/incl/pages/admin/mam.vue"),
    children: [
  {
    name: "admin-mam",
    path: "",
    meta: index0G8ChuPpgY1LTmlaAbyG2ecuxGQtsbtoBGW59XXFfcsMeta || {},
    redirect: "/admin/mam/images",
    component: () => import("/build/incl/pages/admin/mam/index.vue")
  },
  {
    name: "admin-mam-kind",
    path: ":kind()",
    meta: _91kind_93CwxPwVvHorrWREvCBzRhUsNG07f3iUW3ErvwU_9Y33sMeta || {},
    component: () => import("/build/incl/pages/admin/mam/[kind].vue")
  }
]
  },
  {
    name: "box-office",
    path: "/box-office",
    meta: { ...(box_45officesn7igMTSxXVq4zfh0AlGQy71qhGJ1yrMj3Ih1khJzkUMeta || {}), ...{"middleware":["open-feature"]} },
    component: () => import("/build/incl/pages/box-office.vue")
  },
  {
    name: "admin-teams",
    path: "/admin/teams",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/teams.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/users.vue")
  },
  {
    name: "judge",
    path: "/judge",
    meta: { ...(indexzFObHOqlcI7gEk7Ap4pCTk6RpMoOKLLp1GDzuBE3g34Meta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/judge/index.vue")
  },
  {
    name: "admin-sharing",
    path: "/admin/sharing",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/sharing.vue")
  },
  {
    name: "archive",
    path: "/archive",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/archive/index.vue")
  },
  {
    name: "save-the-dates",
    path: "/save-the-dates",
    component: () => import("/build/incl/pages/save-the-dates.vue")
  },
  {
    name: "selection",
    path: "/selection",
    meta: { ...(indexBKR2tkqWgiH_vEdwP3C5xRkdYH5D2P8897kmY47PHkoMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/selection/index.vue")
  },
  {
    name: studio_45linksdVKI0Mo_45ISoh8I5DCg9xXKLMHq4F0yugeNI1PGdD5_45MMeta?.name,
    path: "/admin/studio-links",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/studio-links.vue"),
    children: [
  {
    name: "admin-studio-links",
    path: "",
    component: () => import("/build/incl/pages/admin/studio-links/index.vue")
  },
  {
    name: "admin-studio-links-teamId",
    path: ":teamId()",
    component: () => import("/build/incl/pages/admin/studio-links/[teamId].vue")
  }
]
  },
  {
    name: group_45managerp8RSjL3WeJmxzqXAYo8PhaDEXytj7RB_M8yBMxpUsMwMeta?.name,
    path: "/admin/group-manager",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/group-manager.vue"),
    children: [
  {
    name: "admin-group-manager",
    path: "",
    component: () => import("/build/incl/pages/admin/group-manager/index.vue")
  },
  {
    name: _91groupId_93ewQgYo2loac8YKkkAAlQFh2Ny0skoQTY3g592mD7yOwMeta?.name,
    path: ":groupId()",
    component: () => import("/build/incl/pages/admin/group-manager/[groupId].vue"),
    children: [
  {
    name: "admin-group-manager-groupId",
    path: "",
    component: () => import("/build/incl/pages/admin/group-manager/[groupId]/index.vue")
  },
  {
    name: "admin-group-manager-groupId-people",
    path: "people",
    component: () => import("/build/incl/pages/admin/group-manager/[groupId]/people.vue")
  }
]
  }
]
  },
  {
    name: "admin-registrations",
    path: "/admin/registrations",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/registrations.vue")
  },
  {
    name: "admin-results",
    path: "/admin/results",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/results/index.vue")
  },
  {
    name: "admin-results-judge",
    path: "/admin/results/judge",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/results/judge.vue")
  },
  {
    name: "judge-filmGroupId",
    path: "/judge/:filmGroupId()",
    meta: { ...(_91filmGroupId_93tm0QG_dnn3YVE6do_uRIHm_45biFDjA7akdMouEQDBW8gMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/judge/[filmGroupId].vue")
  },
  {
    name: "prize-sponsor",
    path: "/prize-sponsor",
    component: () => import("/build/incl/pages/prize-sponsor/index.vue")
  },
  {
    name: _91year_93cZik50_45CpV63vSfLOgVpvH95CWfsKUDT9Y7g8jivCdsMeta?.name,
    path: "/admin/results/:year()",
    meta: { ...(_91year_93cZik50_45CpV63vSfLOgVpvH95CWfsKUDT9Y7g8jivCdsMeta || {}), ...{"middleware":["role"]} },
    component: () => import("/build/incl/pages/admin/results/[year].vue"),
    children: [
  {
    name: "admin-results-year",
    path: "",
    component: () => import("/build/incl/pages/admin/results/[year]/index.vue")
  },
  {
    name: _91section_93v3XiKdkJPo3FjD21L23yn6WW9rz1p5mk5MtUqNWqs68Meta?.name,
    path: ":section()",
    meta: _91section_93v3XiKdkJPo3FjD21L23yn6WW9rz1p5mk5MtUqNWqs68Meta || {},
    component: () => import("/build/incl/pages/admin/results/[year]/[section].vue"),
    children: [
  {
    name: "admin-results-year-section",
    path: "",
    component: () => import("/build/incl/pages/admin/results/[year]/[section]/index.vue")
  },
  {
    name: "admin-results-year-section-category",
    path: ":category()",
    component: () => import("/build/incl/pages/admin/results/[year]/[section]/[category].vue")
  }
]
  }
]
  },
  {
    name: "archive-year",
    path: "/archive/:year()",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/archive/[year]/index.vue")
  },
  {
    name: "film-challenge",
    path: "/film-challenge",
    meta: { ...(indexcFkoDdB7HoX1KTYVEaBiZ0i6886D3pZ92tmH3gc86JAMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/film-challenge/index.vue")
  },
  {
    name: "admin-exit-interviews",
    path: "/admin/exit-interviews",
    meta: { ...(exit_45interviewsWNdSBkVNE1Ca1Lma_LaUGe8IUpuGdeEqd9k67o3LhnIMeta || {}), ...{"middleware":["role"]} },
    component: () => import("/build/incl/pages/admin/exit-interviews.vue")
  },
  {
    name: "admin-results-academy",
    path: "/admin/results/academy",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/results/academy.vue")
  },
  {
    name: "archive-year-top-10",
    path: "/archive/:year()/top-10",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/archive/[year]/top-10.vue")
  },
  {
    name: "archive-studios",
    path: "/archive/studios",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/archive/studios/index.vue")
  },
  {
    name: "fivefest-films-create",
    path: "/fivefest/films/create",
    meta: { ...(createEkBK2FrRdzxS_45bc0wztX6arIy5ZWJBGh7mUaMcwbiboMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/fivefest/films/create.vue")
  },
  {
    name: "archive-fivefest",
    path: "/archive/fivefest",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/archive/fivefest/index.vue")
  },
  {
    name: "fivefest-academy",
    path: "/fivefest/academy",
    meta: { ...(indexEDwisKdQM0lWUM0qP6o_BSAbEOKLcZjZwb9dFX7HfVcMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/fivefest/academy/index.vue")
  },
  {
    name: "online-screening",
    path: "/online-screening",
    meta: { ...(indexpRXNOruHMjjYcVvkuK_45uVGg75usWKDGiVCxzcj4_45Tz8Meta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/online-screening/index.vue")
  },
  {
    name: "admin-film-groups-films",
    path: "/admin/film-groups/films",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/film-groups/films.vue")
  },
  {
    name: "admin-film-groups-users",
    path: "/admin/film-groups/users",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/film-groups/users.vue")
  },
  {
    name: "admin-results-selection",
    path: "/admin/results/selection",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/results/selection.vue")
  },
  {
    name: "archive-year-teamId",
    path: "/archive/:year()/:teamId()",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/archive/[year]/[teamId].vue")
  },
  {
    name: "admin-award-winners",
    path: "/admin/award-winners",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/award-winners/index.vue")
  },
  {
    name: "admin-award-winners-year",
    path: "/admin/award-winners/:year()",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/award-winners/[year].vue")
  },
  {
    name: "archive-studios-studioId",
    path: "/archive/studios/:studioId()",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/archive/studios/[studioId].vue")
  },
  {
    name: "film-challenge-inspiration",
    path: "/film-challenge/inspiration",
    component: () => import("/build/incl/pages/film-challenge/inspiration.vue")
  },
  {
    name: "film-challenge-the-matchup",
    path: "/film-challenge/the-matchup",
    meta: { ...(the_45matchupQQa_cfRzEZFjom3NsLs7ZHp4BQiUjvrR0M45k4rJJYwMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/film-challenge/the-matchup.vue")
  },
  {
    name: "archive-year-events",
    path: "/archive/:year()/events",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/archive/[year]/events/index.vue")
  },
  {
    name: "archive-year-events-kind",
    path: "/archive/:year()/events/:kind()",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/archive/[year]/events/[kind].vue")
  },
  {
    name: "admin-audience-favorite",
    path: "/admin/audience-favorite",
    meta: {"middleware":["role"]},
    component: () => import("/build/incl/pages/admin/audience-favorite/index.vue")
  },
  {
    name: "admin-awards-ceremony-checkin",
    path: "/admin/awards-ceremony/checkin",
    meta: { ...(checkin_16RLIFsheEBLes8llqQ61HVvtd6vcQf_45e2cm4JyxVAMeta || {}), ...{"middleware":["role"]} },
    component: () => import("/build/incl/pages/admin/awards-ceremony/checkin.vue")
  },
  {
    name: "archive-fivefest-year",
    path: "/archive/fivefest/:year()",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/archive/fivefest/[year]/index.vue")
  },
  {
    name: "fivefest-films-submissionId",
    path: "/fivefest/films/:submissionId()",
    meta: { ...(_91submissionId_933DqWLTY3fTviFNX8Wv6VrSNAvMDRLya9hJYnEZo1hCgMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/fivefest/films/[submissionId].vue")
  },
  {
    name: "selection-filmGroupId",
    path: "/selection/:filmGroupId()",
    meta: { ...(indexhkqA9n7hgIAHh0iYlM817CqMz5aPMxsR5MktmOlv9W8Meta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/selection/[filmGroupId]/index.vue")
  },
  {
    name: "online-screening-filmGroupId",
    path: "/online-screening/:filmGroupId()",
    meta: { ...(_91filmGroupId_93VepQ0Crf0AlAUy_ghmlHHlNYokgb6bWlu8lh3x_jWRUMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/online-screening/[filmGroupId].vue")
  },
  {
    name: "selection-filmGroupId-review",
    path: "/selection/:filmGroupId()/review",
    meta: { ...(reviewirXv0gPSFK6PiuXXLOexBuD0XjCIjSRb7KE_45Y2hTZ_45AMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/selection/[filmGroupId]/review.vue")
  },
  {
    name: "online-screening-five-fest",
    path: "/online-screening/five-fest",
    meta: { ...(indexOFjQ9XB1BQx8Ideaq0kNfYOe_45gxYeLaxZO0TMCczTFAMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/online-screening/five-fest/index.vue")
  },
  {
    name: "admin-audience-favorite-filmGroupId",
    path: "/admin/audience-favorite/:filmGroupId()",
    meta: { ...(_91filmGroupId_93WQZwPOA609JX7TlVAMLKGEsdn3Tg4TApveEZ7hpf62IMeta || {}), ...{"middleware":["role"]} },
    component: () => import("/build/incl/pages/admin/audience-favorite/[filmGroupId].vue")
  },
  {
    name: "archive-fivefest-year-submissionId",
    path: "/archive/fivefest/:year()/:submissionId()",
    meta: {"middleware":["archive"]},
    component: () => import("/build/incl/pages/archive/fivefest/[year]/[submissionId].vue")
  },
  {
    name: "film-challenge-studios-studioId",
    path: "/film-challenge/studios/:studioId()",
    meta: { ...(index3jhHoFoRQrIJXxIlKJjv_45E8dBLFHuNSoUmOb_GPsE7gMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/film-challenge/studios/[studioId]/index.vue")
  },
  {
    name: "film-challenge-guest-registration-hash",
    path: "/film-challenge/guest-registration/:hash()",
    meta: { ...(_91hash_93zER179T2yvVKapICOIeKdZY8SpQFpi1ZJ6X1BqITnDIMeta || {}), ...{"middleware":["open-feature"]} },
    component: () => import("/build/incl/pages/film-challenge/guest-registration/[hash].vue")
  },
  {
    name: "online-screening-five-fest-filmGroupId",
    path: "/online-screening/five-fest/:filmGroupId()",
    meta: { ...(_91filmGroupId_93kGdNuzSyAOx1U6D_45yJMpP_l70rsXrc3oPFwt6t5vMc0Meta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/online-screening/five-fest/[filmGroupId].vue")
  },
  {
    name: _91filmGroupId_930tbFWWYp6vF8L9wpJFfYa6fK5D4VoZC_45Coue9G0HACIMeta?.name,
    path: "/fivefest/academy/film-groups/:filmGroupId()",
    meta: { ...(_91filmGroupId_930tbFWWYp6vF8L9wpJFfYa6fK5D4VoZC_45Coue9G0HACIMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/fivefest/academy/film-groups/[filmGroupId].vue"),
    children: [
  {
    name: "fivefest-academy-film-groups-filmGroupId",
    path: "",
    component: () => import("/build/incl/pages/fivefest/academy/film-groups/[filmGroupId]/index.vue")
  },
  {
    name: "fivefest-academy-film-groups-filmGroupId-submissionId",
    path: ":submissionId()",
    component: () => import("/build/incl/pages/fivefest/academy/film-groups/[filmGroupId]/[submissionId].vue")
  }
]
  },
  {
    name: "film-challenge-studios-studioId-teams-create",
    path: "/film-challenge/studios/:studioId()/teams/create",
    meta: { ...(createVTWnBRbU0ZYcQQFnEbbzcXhJwN2PZFR9WHiwtdjOutEMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/film-challenge/studios/[studioId]/teams/create.vue")
  },
  {
    name: "film-challenge-studios-studioId-teams-teamId",
    path: "/film-challenge/studios/:studioId()/teams/:teamId()",
    meta: { ...(_91teamId_93BzC8VqAlxC5IIRKMa_45_45_45jwxN_45q_45e7SQdaNqk8htgvjwMeta || {}), ...{"middleware":["auth","open-feature"]} },
    component: () => import("/build/incl/pages/film-challenge/studios/[studioId]/teams/[teamId].vue")
  }
]